module.exports = __webpack_public_path__ + "static/media/clam.eb8e4a56.svg";